import {NAMES} from "@/scripts/components/ab-stars/constants/abStars.constants";
import "./abStarsComponent.scss";
import {AbStarsController} from "@/scripts/components/ab-stars/abStarsController";

export function defineAbStarsElement() {
  const TAG_NAME = NAMES.TAG_NAME;
  if (customElements.get(TAG_NAME)) return;

  class AbStarsElement extends HTMLElement {

    #ctrl?: AbStarsController;

    static get observedAttributes() {
      return ["rating", "selectable", "disabled", "size"];
    }

    connectedCallback() {
      if (this.firstChild) return; // already mounted
      this.#ctrl = new AbStarsController(this);
      this.#ctrl.syncFromAttributes();
      this.#ctrl.render();
      this.#ctrl.bindEvents();
    }

    disconnectedCallback() { }

    attributeChangedCallback() {
      if (!this.isConnected) return;
      this.#ctrl.syncFromAttributes();
      this.#ctrl.render();
    }

  }

  customElements.define(TAG_NAME, AbStarsElement);

}